import { Label } from "@EditArticleContainer/shared/components/EditableTextContainer/types/editableText.types";
import { RightsScopeMAItem } from "@EditArticleContainer/shared/types/paragraphContents/contents/keyRightsMAContent.types";
import { createMultiLineText } from "@utils/createMultiLineText/createMultiLineText";

const toLabels = (labels: unknown): Label[] => (labels ?? []) as Label[];

export const drugText = (item: RightsScopeMAItem) =>
  createMultiLineText({
    textList: item.Drug.value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const drugLabels = (item: RightsScopeMAItem): Label[] =>
  toLabels(item.Drug.value.at(0)?.labels);

export const indicationText = (item: RightsScopeMAItem) =>
  createMultiLineText({
    textList: item.Indication.value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const indicationLabels = (item: RightsScopeMAItem): Label[] =>
  toLabels(item.Indication.value.at(0)?.labels);
